<template>
    <div class='page'>
        <div class='page-content'>
            <div class='page-head'>
                <headers />
            </div>
            <div class='page-body'>
                <div class='Material'>
                    <material />
                </div>
                <div class='Renderer'>
                    <renderer />
                </div>
                <div class='Setting'>
                    <setting />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import headers from '@/components/decoration/layouts/header.vue';
import material from '@/components/decoration/layouts/material.vue';
import renderer from '@/components/decoration/layouts/renderer.vue';
import setting from '@/components/decoration/layouts/setting.vue';

export default {
    components: {
        headers,
        material,
        renderer,
        setting
    },
    data() {
        return {};
    },
    created() {

    },
    mounted() {

    }
};

</script>
<style scoped lang='scss'>
.page-content{
    padding: 10px 0;
}
.page-head {
    width: 100%;
    height: 40px;
}

.page-body {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    .Material {
        width: 400px;
        min-width: 400px;
    }
    .Renderer {
        flex: 1;
        min-width: 500px;
    }
    .Setting {
        width: 420px;
        min-width: 420px;
    }
}
</style>